import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const getTrackingLinkAnalyticsData = (link, analyticsData) => {
  return analyticsData
    ? JSON.stringify({
        eventAction: "my account:orders:order details:tracking link",
        eventName: "my account:orders:order details:tracking link",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "tracking link",
        internalLinkPosition: "order history",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:order details",
        internalLinkURL: link
          ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
          : "n/a",
        clickInternalLinks: "true",
      })
    : null
}

export const cartItemSummaryAnalytics = (
  analyticTitleData,
  productInfoData
) => {
  const eventInfo = analyticTitleData ? JSON.parse(analyticTitleData) : {}
  const productInfo = productInfoData ? JSON.parse(productInfoData) : {}
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, productInfo)
}
